import * as React from "react";
import { AxiosError } from "axios";
import { UseQueryResult } from "react-query";
import { AllChartsData } from "../hooks/useAllChartsData";

type AllChartsDataRefetch = UseQueryResult<
  AllChartsData,
  AxiosError
>["refetch"];

interface AllChartsDataContextValue {
  allChartsData?: AllChartsData;
  allOrderNames?: string[];
  isLoading?: boolean;
  error?: unknown;
  refetch?: AllChartsDataRefetch;
}

const AllChartsDataContext = React.createContext<AllChartsDataContextValue>({
  allChartsData: undefined,
  allOrderNames: undefined,
  isLoading: false,
  error: undefined,
});

export const useAllChartsDataContext = () =>
  React.useContext(AllChartsDataContext);

interface AllChartsDataProviderProps {
  children: React.ReactNode;
  allChartsData?: AllChartsData;
  allOrderNames?: string[];
  isLoading?: boolean;
  error?: unknown;
  refetch?: AllChartsDataRefetch;
}

export const AllChartsDataProvider: React.FC<AllChartsDataProviderProps> = ({
  children,
  allChartsData,
  allOrderNames,
  isLoading,
  error,
  refetch,
}) => {
  return (
    <AllChartsDataContext.Provider
      value={{ allChartsData, allOrderNames, isLoading, error, refetch }}
    >
      {children}
    </AllChartsDataContext.Provider>
  );
};
